import { useCallback, useState } from 'react';

const useApiDelay = <T extends unknown[], R>(asyncCallback: (...args: T) => Promise<R>, delay: number = 100) => {
  const [timeOutId, setTimeOutId] = useState<NodeJS.Timeout | null>(null);

  return useCallback(
    (...args: T): Promise<R | void> => {
      if (timeOutId) clearTimeout(timeOutId);

      return new Promise((resolve, reject) => {
        const id = setTimeout(async () => {
          try {
            const result = await asyncCallback(...args);
            resolve(result);
          } catch (error) {
            reject(error);
          }
        }, delay);

        setTimeOutId(id);
      });
    },
    [asyncCallback, delay, timeOutId],
  );
};

export default useApiDelay;
